// extracted by mini-css-extract-plugin
export default {"remove-y-hidden":"A5GKQ"};